module.exports = __webpack_public_path__ + "img/argendata3.7348d3f6.jpg";